/* eslint-disable global-require */
/**
 * 路由config配置
 */
export const FIRST_LEVEL_HOME = '1000';
export const SECOND_LEVEL_HOMEPAGE = '1001';
export const SECOND_LEVEL_GISMAP = '1002';
export const SECOND_LEVEL_ALARMANDREVENT = '1003';
export const SECOND_LEVEL_LOADPROFILE = '1004';
export const SECOND_LEVEL_ONDEMAND_STATISTIC = '1005';
export const SECOND_LEVEL_DEVICE_OFFLINE_STATISTIC = '1006';
export const SECOND_LEVEL_CONTROL_PANEL = '1007';
export const SECOND_LEVEL_PUSH_STATISTICS = '1008';
export const whitelistMenu = [ FIRST_LEVEL_HOME, SECOND_LEVEL_HOMEPAGE, SECOND_LEVEL_GISMAP, SECOND_LEVEL_ALARMANDREVENT, SECOND_LEVEL_LOADPROFILE, SECOND_LEVEL_ONDEMAND_STATISTIC, SECOND_LEVEL_DEVICE_OFFLINE_STATISTIC ];

import { RouterConfig } from './types';
import {MDRHomePageRouterConfig} from './config/homePage';
import opreateRoleRouterConfig from './config/opreatorMgnt';
import customerAndDevice from './config/customerAndDevice';
import amiFunction from './config/amiFunction';
import configuration from './config/configuration';
import collectReport from './config/collectReport';
import basicData from './config/basicData';
import LogQueryRouterCOnfig from './config/logQuery';
import sinamedAndFacthorRouterCOnfig from './config/sinamedandFacthor';
// import others from './config/others';


const routerConfig: {
  menus: RouterConfig[] | [],
  others: RouterConfig[] | [],
  com: RouterConfig[] | [],
  [index: string]: any;
} = {
    menus: [],
    others: [],
    com: [],
};

routerConfig.menus = [
    ...MDRHomePageRouterConfig,
    ...customerAndDevice,
    ...amiFunction,
    ...basicData,
    ...configuration,
    ...collectReport,
    ...LogQueryRouterCOnfig,
    ...opreateRoleRouterConfig,
    ...sinamedAndFacthorRouterCOnfig,
];
// routerConfig.others = others;

export default routerConfig;

